import { rankWith, uiTypeIs } from '@jsonforms/core';
import { Divider } from '@mui/material';
import React from 'react';
import { withJsonFormsLayoutProps } from '@jsonforms/react';

const DividerRenderer = props => {
  const { uischema } = props;
  const orientation = uischema.options?.orientation;

  return (
    <Divider sx={{ mt: 2, mb: 2, color: '#00AB55', fontSize: '24px' }} orientation={orientation}>{uischema.text}</Divider>
  );
};

export default withJsonFormsLayoutProps(DividerRenderer);

export const DividerTester = rankWith(1000, uiTypeIs('Divider'));
